import { JourneyFilterPropertyOptionData } from '@/components/FilterManager/CustomFilterProperties/JourneyFilterProperties/types';
import {
  ContentEntity,
  FilterOperatorEnum,
  FilterPropertyTypeEnum,
  QuestionType,
  TagTypeEnum,
  TagUnion,
  TypeCastEnum,
} from '@/types/schema';

export type FilterPropertyInputType = {
  type: FilterPropertyTypeEnum;
  value: string;
  tag?: TagUnion | null;
  meta?: string;
  content?: ContentEntity | JourneyFilterPropertyOptionData;
  question?: QuestionType;
};

export type FilterGroup = {
  operator: FilterOperatorEnum;
};

export type FilterInputsD2 = {
  operator?: FilterOperatorEnum;
  property?: FilterPropertyInputType;
  value?: string;
  tagType?: TagTypeEnum;
  typeCast?: TypeCastEnum;
};

export type FilterInputsD1 = {
  operator: FilterOperatorEnum;
  filters: FilterInputsD2[];
};

export type FilterGroupInput = {
  operator: FilterOperatorEnum;
  filters: FilterInputsD1[];
};

export enum GroupConditionAction {
  Duplicate = 'DUPLICATE',
  Delete = 'DELETE',
}

export interface AllowedFieldsInConditionalFieldsMapping {
  value: string;
  label: string;
  allowedOperators: FilterOperatorEnum[];
}
export interface ConditionalFieldsMapping {
  parentEntity: string;
  childEntity: string;
  allowedFields: AllowedFieldsInConditionalFieldsMapping[];
}
export interface ConditionalFieldsMappingResponse {
  fieldConfigs: ConditionalFieldsMapping[];
}
